// Meta's click identifiers, read from the browser that is about to talk to us.
//
// Two callers, two reasons. The lead capture on /ig needs them because TrapMan
// is a desktop plugin: the phone that clicked the ad is never the browser that
// creates the account, so the server has to store these at capture time and
// replay them on every later event (see the spec at
// docs/superpowers/specs/2026-08-22-meta-ads-ig-funnel-design.md).
//
// Signup needs them for the opposite case — someone who clicked the ad and
// signed up in that same browser, leaving no lead row behind. There the
// cookies in front of us are the only copy that exists, and without them the
// server can report nothing at all.
const FBC_PREFIX = "fb.1";

function readCookie(name) {
  try {
    const entry = document.cookie
      .split(";")
      .map((part) => part.trim())
      .find((part) => part.startsWith(`${name}=`));
    return entry ? decodeURIComponent(entry.slice(name.length + 1)) : null;
  } catch {
    return null;
  }
}

export function metaClickIds() {
  try {
    const fbclid = new URLSearchParams(window.location.search).get("fbclid") || null;
    // The pixel's own _fbc cookie is preferred over rebuilding the value: it
    // was stamped with the timestamp of the click itself, while anything we
    // compute here is stamped with the submit. Rebuilding is the fallback for
    // the visitors the pixel never loaded for (consent gate, ad blocker), and
    // it is still device-independent once the server stores it.
    const fbc = readCookie("_fbc") || (fbclid ? `${FBC_PREFIX}.${Date.now()}.${fbclid}` : null);
    return { fbclid, fbp: readCookie("_fbp"), fbc };
  } catch {
    return {};
  }
}
